import React from 'react';
import { Link } from '../../visions/vx-link';
import flyerPdf from 'file-loader?name=docs/[name].[ext]!../../../assets/docs/compressedupdatedglobalrecallsflyer.compressed.pdf';

const AboutPortal = (props) => (
	<div className="container main">
		<h2>ポータルについて</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<iframe width="100%" height="310" src="https://player.vimeo.com/video/170923073" frameBorder="0" allowFullScreen=""/>
			</div>
			<div className="col-sm-6">
				<h4><em>GlobalRecalls</em>ポータルとは？</h4>
				<p>
					<em>GlobalRecalls</em>ポータルは、世界中の製品リコール情報を一箇所に集め、定期的にOECDのプラットフォーム上でまとめて提供しています。
					このポータルには、政府機関が公開した、または政府機関に申請された消費者製品の強制および任意のリコールに関する公開情報が掲載されます。
					リコールの対象は情報提供者である特定の政府機関の権限によって決定されます。
					場合によっては、食品、車両、医薬品のリコールが含まれます。
				</p>
				<p><em>GlobalRecalls</em>ポータルは2012年10月19日に導入されました。</p>
			</div>
		</div>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>このポータルを利用できるのは誰ですか？</h4>
				<p>
					<em>GlobalRecalls</em>ポータルは各国・地域間における情報共有を促進し、規制当局の是正措置を支援します。
					独自の電子製品のリコールデータベースを持つすべての国・地域は、ポータルへの貢献を求められています。
				</p>
				<p>
					消費者や企業もこのポータルの恩恵を受けることができます。
					消費者はこのポータルを使って購入を検討している製品に安全上の問題がないかどうかを確認できるため、特にオンラインで海外から製品を購入する際に役立ちます。
					また、企業の利用者は、世界中で新たに生じている危険有害性をいち早く把握し、自社製品の問題によりすばやく対処するためこのポータルを役立てられるかもしれません。
				</p>
				<p>このポータルは、独自のオンライン消費者製品リコールデータベースを持たない国の規制当局、消費者、および企業にとって特に貴重な情報源となります。</p>
			</div>
			<div className="col-sm-6">
				<h4>このポータルにはどのようなリコールが含まれますか？</h4>
				<p>
					<em>GlobalRecalls</em>ポータルには現在、世界47の国・地域からの消費者製品のリコールが含まれており、欧州連合およびASEAN地域のリコールポータルからのリコールが集積されています。
					このポータルは、参加国・地域の新旧データも含めて定期的に更新されます。
				</p>
				<p>
					各国・地域が「消費者製品」として定義する製品のタイプはそれぞれ若干異なる場合があります。
					例えば、化粧品を消費者製品のリコールに含める国もあれば、車両を含める国もあります。
				</p>
			</div>
		</div>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>ポータルはどのように更新されるのですか？</h4>
				<p>
					各国・地域は、ポータルに情報を送信する頻度と時期を決定し、各自のシステムに応じて一部の国・地域では自動的に送信し、他の国・地域では手動で送信します。
					更新は毎日から毎週、あるいは毎月と異なる場合があります。
				</p>
			</div>
			<div className="col-sm-6">
				<h4>ポータルでリコールを利用できる期間はどれくらいですか？</h4>
				<p>ポータルの情報は各国・地域が許す限り保存されます。したがって、無期限に閲覧可能な情報もあります。</p>
			</div>
		</div>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>リコール情報がポータルに掲載されていても、該当する国・地域のリコールウェブサイトには載っていない場合や、あるいはその逆の場合もありえますか？</h4>
				<p>
					ポータルで共有する情報の選択は各参加国・地域の判断に委ねられます。
					そのため、国・地域によっては、特定のリコールに関する詳細情報が国内サイトに掲載されている場合があります。
				</p>
				<p>しかし、各参加国・地域は通常、このポータルを通してすべての公開情報を共有することにコミットしています。</p>
			</div>
		</div>
	</div>
);

export default AboutPortal;



// WEBPACK FOOTER //
// ./src/views/static/ja/about-portal.js